import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchAnalyticsReports = createAsyncThunk(
    'user/fetchAnalyticsReports',
    async ({user}) => {
        try {
            const analyticsReport = await fetchFun(`/api/v1/analytics/v2?userId=${user?._id}`);
            if(analyticsReport?.success) {
                return analyticsReport.data
            }
        } catch(error) {
            console.log("Error - /checks", error)
        }
    }
)